<!-- 订单支付页面    https://htapi.zxznzy.com  https://htapi.zxznzy.com/    -->
<template>
  <div class="orderPay">
    <div class="orderPay_title">功能套餐</div>
    <!-- 顶部背景图片 -->
    <div class="img_block">
      <img
        class="logo_des"
        src="@/assets/adule_img/btnList/logo_des.png"
        alt=""
      />
      <img class="seat" src="@/assets/adule_img/btnList/seat2.png" alt="" />
    </div>
    <!-- 套餐价格 -->
    <div class="priceList">
      <div class="priceList_tips">
        孕妇、心脑血管疾病患者或体内安装医用器械者禁止按摩
      </div>
      <!-- <div
        class="line"
        @click="handleSelect('1')"
        :class="active == 1 ? 'activeClass' : ''"
      >
        <div class="line_text">免费畅享</div>
        <div class="line_time">5分钟</div>
        <div class="line_price">免费</div>
      </div> -->
      <div>
        <template v-if="priceList[2][0]">
          <div
            class="line"
            @click="handleSelect('2', priceList[2][0])"
            :class="active == 2 ? 'activeClass' : ''"
          >
            <div class="line_text">惬意舒展</div>
            <div class="line_time">{{ priceList[2][0].time_one }}分钟</div>
            <div class="line_price">￥{{ priceList[2][0].money_one }}</div>
          </div>
        </template>
        <template v-if="priceList[2][1]">
          <div
            class="line"
            @click="handleSelect('3', priceList[2][1])"
            :class="active == 3 ? 'activeClass' : ''"
          >
            <div class="line_text">舒筋活络</div>
            <div class="line_time">{{ priceList[2][1].time_one }}分钟</div>
            <div class="line_price">￥{{ priceList[2][1].money_one }}</div>
          </div>
        </template>
        <template v-if="priceList[2][2]">
          <div
            class="line line3"
            @click="handleSelect('4', priceList[2][2])"
            :class="active == 4 ? 'activeClass' : ''"
          >
            <div class="icon">
              <img
                class="hot"
                src="@/assets/adule_img/btnList/hot.png"
                alt=""
              />
              <span class="icon_text">最多人选</span>
            </div>
            <div class="line_text">消疲解乏</div>
            <div class="line_time">{{ priceList[2][2].time_one }}分钟</div>
            <div class="line_price">￥{{ priceList[2][2].money_one }}</div>
          </div>
        </template>
        <template v-if="priceList[2][3]">
          <div
            class="line line5"
            @click="handleSelect('5', priceList[2][3])"
            :class="active == 5 ? 'activeClass' : ''"
          >
            <div class="line_text">悦享睡眠</div>
            <div class="line_time">{{ priceList[2][3].time_one }}分钟</div>
            <div class="line_tips">（另赠1小时=3小时）</div>
            <div class="line_price">￥{{ priceList[2][3].money_one }}</div>
          </div>
        </template>
        <template v-if="priceList[2][4]">
          <div
            class="line line5"
            @click="handleSelect('6', priceList[2][4])"
            :class="active == 6 ? 'activeClass' : ''"
          >
            <div class="line_text">至尊套餐</div>
            <div class="line_time">{{ priceList[2][4].time_one }}分钟</div>
            <!-- <div class="line_tips">（另赠1小时=3小时）</div> -->
            <div class="line_price">￥{{ priceList[2][4].money_one }}</div>
          </div>
        </template>
      </div>
      <!-- 结算套餐 -->
      <div style="display: flex; align-items: center; justify-content: center">
        <div
          class="btnFoot"
          style="
            width: 70%;
            text-align: center;
            background-color: black;
            color: white;
            height: 50px;
            line-height: 50px;
            border-radius: 10px 0 0 10px;
          "
        >
          <span class="btnFoot_R_time">{{ itemObj.time_one }}分钟</span>
          <span class="btnFoot_R_price" style="font-size: x-large"
            >/￥{{ itemObj.money_one }}</span
          >
        </div>
        <div
          style="
            width: 30%;
            text-align: center;
            background-color: #23c2c0;
            color: white;
            height: 50px;
            line-height: 50px;
            border-radius: 0 10px 10px 0;
          "
        >
          <span class="confirmBtn" @click="handlePay">确认付款</span>
        </div>
      </div>
      <!-- <div style="display: flex; align-items: stretch; justify-content: center;">
          <div class="btnFoot" style="width: 70%; text-align: center; background-color: black; color: white; height: 50px; line-height: 50px; border-radius: 10px 0 0 10px;">
            <span class="btnFoot_R_time">{{ itemObj.time_one }}分钟</span>
            <span class="btnFoot_R_price">/￥{{ itemObj.money_one }}</span>
          </div>
          <div style="width: 30%; text-align: center; background-color: #23c2c0; color: white; height: 50px; line-height: 50px; border-radius: 0 10px 10px 0;">
            <span class="confirmBtn" @click="handlePay">确认付款</span>
          </div>
        </div> -->
    </div>
    <!--底部按钮 -->
    <!-- <div class="btnFoot_block">
      <img
        class="btnFoot_L"
        src="@/assets/adule_img/btnList/btn_f1.png"
        alt=""
      />
      <div class="btnFoot_R" v-if="itemObj && itemObj.time_one">
        <div class="btnFoot">
          <span class="btnFoot_R_time">{{ itemObj.time_one }}分钟</span>
          <span class="btnFoot_R_price">/￥{{ itemObj.money_one }}</span>
        </div>
      </div>
      <span class="confirmBtn" @click="handlePay">确认付款</span>
    </div> -->

    <!-- 套餐价格 -->
    <!-- <div class="priceList">
      <div
        class="line"
        v-for="(item, index) in priceList"
        :key="index"
        @click="handleClick(item)"
      >
        <div class="numInput">
          <div class="time">{{ item.time_one }}</div>
          <div>￥{{ item.money_one }}</div>
        </div>
      </div>
    </div> -->
    <!-- 按钮 -->
    <!-- <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
      "
    >
      <div class="btn btn2" @click="handlePay">支付</div>
      <div class="btn" @click="handleOrderList">订单列表</div>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "WorkspaceJsonOrderPay",

  data() {
    return {
      // 价格表
      priceList: {
        2: [], // 确保 priceList[2] 初始化为数组
      },
      params: {}, // 支付参数
      js_code: "", // jscode从URL获取
      equ_no: "",
      open_id: "", //用户open_id
      project_no: "", // 项目编号从URL获取
      itemObj: {
        time_one: "0", // 默认时间
        money_one: "0", // 默认金额
      },
      // price_type: "", // 价格类型
      active: "4", // 当前选中的套餐
      priceCopyList: {
        1: [],
        2: [
          { money_one: "0.01", time_one: "30" },
          { money_one: "0.01", time_one: "60" },
          { money_one: "0.01", time_one: "90" },
          { money_one: "0.01", time_one: "180" },
        ],
      },
    };
  },
  async mounted() {
    // 获取传递的 price_type 参数
    // this.price_type = this.$route.query.price_type || "";
    // 获取套餐价格
    await this.getPriceList();
    // 获取js_code和openid
    // await this.getOpenId();
    // 默认选择套餐
    this.handleSelect();
  },

  methods: {
    // 获取套餐价格接口
    async getPriceList() {
      try {
        const res = await axios.get(
          "https://htapi.zxznzy.com/project/get_money_list",
          {
            params: {
              equ_id: localStorage.getItem("text") || "861538074490688",
            },
          }
        );
        if (res.data.code === 200) {
          this.priceList = res.data.pro_money_list[0].money_list || { 2: [] }; // 兜底空数组
          this.project_no = res.data.pro_money_list[0].project_no;
          this.equ_no = res.data.pro_money_list[0].equ_no;
          if (this.equ_no == "50000000134") {
            this.priceList = this.priceCopyList;
          }
          // localStorage.setItem("is_running", res.data.is_running);
          this.handleSelect(); // 数据加载后设置默认选中项
        }
      } catch (err) {
        alert('服务出差了，联系客服赠送免费时长');
        // alert(err.response.data.message);
        console.error("获取价格列表失败:", err);
      }
    },
    // 选择套餐
    handleSelect(type, item) {
      this.active = type || "4"; // 默认选中价格9的套餐
      this.itemObj = item || this.priceList[2][2];
    },

    // 支付
    handlePay() {
      if (JSON.stringify(this.itemObj) === "{}") {
        return this.$message.error("请选择功能套餐");
      }
      // 获取支付参数
      this.getPaymentParams();
    },
    // 获取支付参数
    async getPaymentParams() {
      axios({
        method: "post",
        url: "https://htapi.zxznzy.com/project/wx_pay_h5",
        data: {
          equ_no: this.equ_no,
          equ_id: localStorage.getItem("text"),
          project_no: this.project_no,
          equ_price: this.itemObj.money_one, // 金额
          open_minus: this.itemObj.time_one, // 时长
          price_type: "2", // 价格类型
          open_id: localStorage.getItem("open_id"),
        },
      })
        .then((response) => {
          if (response.data.code == 200) {
            // alert("获取支付参数" + JSON.stringify(response.data));
            this.onBridgeReady(response.data);
          } else {
            this.$message.error("error get opneid2");
            throw new Error(response.data.errmsg || "未知错误");
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },

    /* eslint-disable */
    async onBridgeReady(params) {
      try {
        // 添加请求超时处理
        const timer = setTimeout(() => {
          alert("支付超时，请刷新页面重试");
        }, 10000); // 10秒超时

        WeixinJSBridge.invoke("getBrandWCPayRequest", params, (res) => {
          clearTimeout(timer);

          if (res.err_msg === "get_brand_wcpay_request:ok") {
            // 跳转到订单列表
            this.$router.push({ path: "/orderList" });
          } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
            alert("您已取消支付，可到订单页面重新支付");
          } else {
            alert(`支付失败: ${res.err_msg || "未知错误"}`);
          }
        });
      } catch (error) {
        alert("系统繁忙，请稍后重试 (CODE:500)");
      }
    },

    // 获取用户js_code
    // async getOpenId() {
    //   // 尝试从URL参数获取code
    //   this.js_code = this.getcode("code");
    //   localStorage.setItem("js_code", this.js_code);
    //   // 向后端请求openid
    //   try {
    //     await this.fetchOpenId();
    //   } catch (err) {
    //     this.error = "获取OpenID失败: " + err.message;
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // 获取URL参数
    // getcode(name) {
    //   const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
    //   const r = window.location.search.substr(1).match(reg);
    //   if (r != null) return decodeURIComponent(r[2]);
    //   return null;
    // },
    // 获取openid
    // fetchOpenId() {
    //   try {
    //     axios({
    //       method: "get",
    //       url: "https://htapi.zxznzy.com/project/get_code",
    //       params: {
    //         code: localStorage.getItem("js_code"),
    //       },
    //     })
    //       .then((response) => {
    //         if (response.data.openid) {
    //           this.open_id = response.data.openid;
    //           localStorage.setItem("open_id", this.open_id); // 存储open_id到本地存储
    //         }
    //       })
    //       .catch((err) => {
    //         console.log("222", err);
    //         // this.$message.error(
    //         //   error.response.data.message || error.response.data.errmsg
    //         // );
    //       });
    //   } catch (error) {
    //     console.log("error", error);
    //   }
    // },
    /* eslint-enable */
    handleClick(item) {
      this.itemObj = item;
    },

    handleOrderList() {
      // 跳转到订单列表
      this.$router.push({ path: "/orderList" });
    },
    // 体验
    handleExepre() {
      // window.location.href = "https://zxkj.zxznzy.com/AdultSeat";
    },
  },
};
</script>

<style lang="scss" scoped>
.orderPay {
  background: linear-gradient(to bottom, #9afffc, #fff);
  background-size: cover;
  width: 100%;
  height: 100vh;
  position: relative;
  padding: 10px 15px 0;
  box-sizing: border-box;
  .orderPay_title {
    font-family: FZLanTingHeiS-DB-GB;
    font-weight: 400;
    font-size: 17px;
    color: #000000;
    text-align: center;
  }
  .img_block {
    margin-top: 20px;
    .logo_des {
      width: 180px;
      height: 89px;
    }
    .seat {
      width: 150px;
      height: 241px;
      position: absolute;
      right: 15px;
      top: -30px;
      z-index: 1;
    }
  }

  .priceList {
    width: 93vw;
    background: #fff;
    z-index: 2;
    position: absolute;
    margin-top: 1vh;
    border-radius: 20px;
    padding: 0 10px;
    box-sizing: border-box;
    .priceList_tips {
      font-family: FZLanTingHeiS-DB-GB;
      font-weight: 400;
      font-size: 12px;
      color: #656565;
      text-align: center;
      margin-top: 3vh;
      margin-bottom: 3vh;
    }
    .line {
      width: 100%;
      display: flex;
      align-items: center;
      background: #f0f2f2;
      border-radius: 10px;
      padding: 3vh 1vw 3vh 7vw;
      box-sizing: border-box;
      margin-bottom: 2vh;
      .line_text {
        width: 40%;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 17px;
        color: #000000;
      }
      .line_time {
        width: 30%;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 17px;
        color: #000000;
      }
      .line_price {
        width: 30%;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 17px;
        color: #23c2c0;
      }
    }
    .line3 {
      position: relative;
      .icon {
        position: absolute;
        left: 0;
        top: 0;
        background: #23c2c0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3px;
        border-radius: 4px;
        .hot {
          width: 10px;
          height: 10px;
        }
        .icon_text {
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          font-size: 9px;
          color: #ffffff;
        }
      }
    }
    .line5 {
      position: relative;

      .line_tips {
        position: absolute;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 10px;
        color: #23c2c0;
        top: 7vh;
        left: 33vw;
      }
    }
    .line.activeClass {
      border: 4px solid #23c2c0;
    }
  }
  .btnFoot_block {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 3vh;
    .btnFoot_L {
      width: 25vw;
      height: 9vh;
    }
    .btnFoot_R {
      width: 68vw;
      height: 9vh;
      background: url("@/assets/adule_img/btnList/btn_f2.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: 23vw;
      .btnFoot {
        position: absolute;
        left: 4vw;
        top: 2.3vh;
        .btnFoot_R_time {
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
        }
        .btnFoot_R_price {
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          font-size: 21px;
          color: #ffffff;
        }
      }
    }
    .confirmBtn {
      font-family: FZLanTingHeiS-DB-GB;
      font-weight: 400;
      color: #ffffff;
      position: absolute;
      right: -64vw;
      padding: 16px;
      box-sizing: border-box;
    }
  }
}
</style>
